// extracted by mini-css-extract-plugin
export default {"background":"ModalWindow_background__ByJpJ","container":"ModalWindow_container__de6QE"};